var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.808 3.015c-.466.504-.466 1.247-.466 2.733v.724c0 1.475 0 2.213.465 2.716s1.18.559 2.611.67c2.103.165 5.12.337 8.534.337 3.414 0 6.431-.172 8.534-.336 1.43-.113 2.146-.17 2.61-.672.466-.503.466-1.24.466-2.716v-.724c0-1.486 0-2.23-.466-2.733s-1.19-.559-2.639-.67A113.03 113.03 0 0 0 15.952 2c-3.275 0-6.346.178-8.505.344-1.45.112-2.173.168-2.64.671zm-.48 13.854c.104-.865.156-1.297.528-1.595.371-.298.802-.255 1.664-.169.521.052 1.154.125 1.906.227.707.095 1.33.26 1.862.452.79.283 1.186.424 1.717 1.18.532.755.532 1.383.532 2.638v8.648c0 .825 0 1.237-.256 1.494-.256.256-.668.256-1.493.256H7.447c-1.355-.003-2.033-.004-2.532-.457-.5-.453-.562-1.092-.688-2.37A48.144 48.144 0 0 1 4 22.489c0-2.333.168-4.288.328-5.619zm22.908 0c-.104-.865-.155-1.297-.527-1.595-.373-.298-.804-.255-1.666-.169a55.43 55.43 0 0 0-1.906.227c-.707.095-1.33.26-1.862.452-.79.283-1.185.424-1.717 1.18-.532.755-.532 1.383-.532 2.638v8.648c0 .825 0 1.237.256 1.494.256.256.668.256 1.493.256H24.117c1.355-.003 2.033-.004 2.532-.457.499-.453.562-1.092.687-2.37.123-1.245.227-2.847.227-4.685 0-2.333-.168-4.288-.328-5.619z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribe);
export default __webpack_public_path__ + "static/media/TRIBE.9e1caff7ef1d151777bf41b690ae1987.svg";
export { ForwardRef as ReactComponent };